import {
  HealthcareProviderInformationRequest,
  HealthcareUnitRequest,
  HealthcareUnitResponse,
} from 'requests/nswag/nll/NLLClient';

export const createUpdateRequest = (
  customerId: string,
  healthProviderName: string | null | undefined,
  healthcareUnits: HealthcareUnitResponse[],
): HealthcareProviderInformationRequest => {
  return new HealthcareProviderInformationRequest({
    customerId: customerId,
    name: healthProviderName,
    healthcareUnits: healthcareUnits.map(
      (unit) =>
        new HealthcareUnitRequest({
          location: unit.location,
          hsaId: unit.hsaId,
          organisationId: unit.organisationId,
          name: unit.name,
        }),
    ),
  });
};
